module.exports = __webpack_public_path__ + "static/img/my_bg.bd4b7d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/my_bg.png
// module id = whQD
// module chunks = 0